import { useMemo } from 'react';

const useTabManager = (tabs, maxLeftTabs = 2) => {
  // Split tabs into left and right groups
  const { leftTabs, rightTabs } = useMemo(() => {
    const leftTabs = tabs.slice(0, maxLeftTabs);
    const rightTabs = tabs.length > maxLeftTabs ? tabs.slice(maxLeftTabs) : [];
    return { leftTabs, rightTabs };
  }, [tabs, maxLeftTabs]);

  const editFieldHandler = (e, formData, setFormData) => {
    const { name, value } = e.target;
  
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    return formData;
  };
  

  return { leftTabs, rightTabs, editFieldHandler };
};

export default useTabManager;
